import { FC } from 'react';

import IngredientListing from 'components/main/Reports/Ingredients';

const Ingredient: FC = () => <IngredientListing />;

export default Ingredient;
